/**
 * UpDog Challenge Game Rules & Scoring Matrix
 * Extracted from Scout's Pals Scorer User Guide
 */
export const gameRules = [
  {
    name: "Throw N Go (L1 & L2)",
    timeLimit: "60 sec",
    fieldLayout: "Linear Zones (10, 20, 30, 40, 50 yds)",
    rules: "Zones 1–4 (1, 2, 3, 5 pts). Sweet Spot bonus (+2 pts). Airborne bonus in L2 (+1 pt). Max 2 catches per zone.",
    category: "Distance / Accuracy",
    highlights: ["Max 2 catches/zone", "Sweet Spot (+2)", "Airborne bonus (L2)"]
  },
  {
    name: "4-Way Play (L1 & L2)",
    timeLimit: "60 sec",
    fieldLayout: "4 Directional Quadrants",
    rules: "Zones 1–4 (1, 2, 3, 4 pts). Catch in each quadrant earns a 4-Way Bonus (+4 pts). Sweet Spot (+2 pts).",
    category: "Strategy",
    highlights: ["4 Quadrants", "4-Way Bonus (+4)", "Sweet Spot (+2)"]
  },
  {
    name: "Frizgility (L1 & L2)",
    timeLimit: "60 sec",
    fieldLayout: "Alternating Disc Throw & Agility Obstacles",
    rules: "Alternate between catch zones and obstacles (tunnel, hurdles). Completed clean sequences score combo points.",
    category: "Agility / Hybrid",
    highlights: ["Tunnel & Hurdles", "Clean sequences", "Combo multipliers"]
  },
  {
    name: "FunKey (L1 & L2)",
    timeLimit: "60 sec",
    fieldLayout: "3 Position Keys & Far Zones",
    rules: "Unlock keys in sequence to activate multipliers for outer zone catches.",
    category: "Strategy",
    highlights: ["Key sequence unlocking", "Outer zone multipliers", "Tactical pathing"]
  },
  {
    name: "Time Warp (L1 & L2)",
    timeLimit: "60 sec",
    fieldLayout: "4 Zones with Time Warp portal",
    rules: "Catches in the warp zone earn double points or trigger special bonus periods.",
    category: "Strategy",
    highlights: ["Warp Zone", "Double points", "Bonus timer triggers"]
  },
  {
    name: "Spaced Out (L1, L2, L3)",
    timeLimit: "60 sec",
    fieldLayout: "Planetary Zones (Mercury to Neptune)",
    rules: "Catch targets at varying depths. Level 2 & 3 introduce hazard orbits and retrograde bonuses.",
    category: "Distance / Accuracy",
    highlights: ["Planetary depth targets", "Hazard orbits", "Retrograde bonuses"]
  },
  {
    name: "Greedy",
    timeLimit: "60 sec",
    fieldLayout: "Linear Zones",
    rules: "Bank points as you go; each consecutive catch increases multiplier, but a miss zeroes unbanked points.",
    category: "Strategy",
    highlights: ["Point banking", "Consecutive multipliers", "Miss wipes unbanked"]
  },
  {
    name: "Boom!",
    timeLimit: "60 sec",
    fieldLayout: "Multi-Zone Grid",
    rules: "Hit designated trigger zones to detonate multipliers across neighboring zones.",
    category: "Strategy",
    highlights: ["Trigger detonators", "Zone blast multipliers", "Grid strategy"]
  },
  {
    name: "Fireball",
    timeLimit: "60 sec",
    fieldLayout: "Rapid-fire throwing",
    rules: "3 consecutive successful catches activate Fireball mode for multiplied scoring.",
    category: "Speed",
    highlights: ["3 consecutive catch trigger", "Fireball combo mode", "High-tempo release"]
  },
  {
    name: "7 Up",
    timeLimit: "60 sec",
    fieldLayout: "7 Target Zones",
    rules: "Successfully score in 7 distinct zones to trigger the 7 Up completion bonus.",
    category: "Strategy",
    highlights: ["7 Unique zones", "Completion mega-bonus", "Full field coverage"]
  },
  {
    name: "Far Out",
    timeLimit: "3 throws",
    fieldLayout: "Long distance field",
    rules: "3 attempts to score the longest catch possible; highest single catch distance determines rank.",
    category: "Distance / Accuracy",
    highlights: ["3 Throw attempts", "Longest catch wins", "Max distance target"]
  },
  {
    name: "Freestyle (L1 & L2)",
    timeLimit: "120 sec",
    fieldLayout: "Open Field (No zones)",
    rules: "Judged criteria scoring: Canine Athl., Handler Athl., Disc Athl., Sequence / Flow, Catch Ratio.",
    category: "Judged",
    highlights: ["5 Judged categories", "120s Music routine", "Athleticism & Catch ratio"]
  },
  {
    name: "K9 Toss and Fetch",
    timeLimit: "60 sec",
    fieldLayout: "Standard 50-yd field",
    rules: "Standard K9 Toss and Fetch worldwide scoring with 10–50 yard zones and club division tracking.",
    category: "Distance / Accuracy",
    highlights: ["Worldwide standard rules", "10–50 yard zones", "Club division rank"]
  }
];
